import React, { Component } from "react";
import TreeNode from "./TreeNode";
import DialogActions from "@material-ui/core/DialogActions";
import DialogTitle from "@material-ui/core/DialogTitle";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import { Trans, withTranslation } from "react-i18next";
import Button from "@material-ui/core/Button";
import CardHeader from "@material-ui/core/CardHeader";
import SwipeableViews from "react-swipeable-views";
import DisplayDecisionTree from "./DisplayDecisionTree";
import KpsEditor from "../editor/KpsEditor";
import { v4 as uuidv4 } from "uuid";
import { containsScriptOrSVG, containsBadCharacter } from "../../utils/ContentChecker";
class DecisionTree extends Component {
  render() {
    return (
      <>
        <SwipeableViews
          index={this.state.selected}
          id="pages"
          style={{ paddingTop: "16px" }}
        >
          <div>
            <div style={{ textAlign: "center" }}>
              <Button
                variant="outlined"
                onClick={() => this.changeDisplayTree(1)}
              >
                Preview Tree
              </Button>
            </div>
            <div>
              <TreeNode
                handleDrop={(node) => this.drop(node)}
                cutNode={this.cutNode}
                dragNode={this.state.dragNode}
                changeType={this.changeType}
                copyNode={this.state.copyNode}
                addAsCopy={this.addAsCopy}
                pasteNode={this.pasteNode}
                changeNotes={this.changeNotes}
                selectNode={this.selectNode}
                selectedNode={this.state.selectedNode}
                count={0}
                parentNumber={this.props.tree.number}
                node={
                  typeof this.props.tree === "string" ||
                  this.props.tree instanceof String
                    ? JSON.parse(this.props.tree)
                    : this.props.tree
                }
                addChild={this.addChild}
                updateTitle={this.updateTitle}
                deleteNode={this.deleteNode}
              />
            </div>
          </div>
          <div>
            <DisplayDecisionTree
              title={this.props.title}
              changeDisplayTree={this.changeDisplayTree}
              node={
                typeof this.props.tree === "string" ||
                this.props.tree instanceof String
                  ? JSON.parse(this.props.tree)
                  : this.props.tree
              }
            />
          </div>
        </SwipeableViews>

        <Dialog open={this.state.editNotes} fullscreen disableEnforceFocus={true}>
          <DialogTitle id="api-dialog-title">Edit node notes</DialogTitle>
          <DialogContent>
            <KpsEditor
              initialContent={this.state.selectedNode.notes}
              updateUploadArray={this.props.updateUploadArray}
              onChange={(edit) =>
                this.setState({
                  selectedNode: {
                    ...this.state.selectedNode,
                    notes: edit,
                  },
                })
              }
              newUploadId={this.newUploadId}
            />
          </DialogContent>
          <DialogActions>
            <Button
              onClick={() => this.setState({ editNotes: false })}
              color="primary"
            >
              <Trans i18nKey="global_cancel" />
            </Button>
            <Button onClick={this.notesChanged} color="primary">
              <Trans i18nKey="global_save" />
            </Button>
          </DialogActions>
        </Dialog>
      </>
    );
  }
  changeDisplayTree = (num) => {
    this.setState({ selected: num });
  };
  drop = (node) => {
    console.log(node);
  };
  changeType = (node, type) => {
    let rootCopy = { ...this.props.tree };
    node = this.findNode(node.number, rootCopy);
    node.type = type.target.value;
    if (node.type === "decision") {
      node.children = [];
    }
    // this.setState({ tree: rootCopy });
    this.props.handleChange(rootCopy);
    this.setState({ incomplete: false });
    if (this.props.setIncomplete) {
      this.props.setIncomplete(false);
    }
    this.checkIfComplete(this.props.tree);
  };
  cutNode = (cutNode, parentNodeId) => {
    this.addAsCopy(cutNode);
    this.deleteNode(parentNodeId, cutNode);
  };

  updateTitle = (node, title) => {
    let rootCopy = { ...this.props.tree };
    node = this.findNode(node.number, rootCopy);
    node.label = title.target.value;
    // this.setState({ tree: rootCopy });
    this.props.handleChange(rootCopy);
  };
  notesChanged = () => {
    if (containsScriptOrSVG([this.state.selectedNode.notes])) {
      this.props.setGlobalAlert({type:"error", message:"harmful_content", open:true})
      return;
    } else if (containsBadCharacter([this.state.selectedNode.notes])){
      this.props.setGlobalAlert({type:"error", message:"unusable_character", open:true})
      return;
    }    
    let rootCopy = { ...this.props.tree };
    let node = this.findNode(this.state.selectedNode.number, rootCopy);
    node.notes = this.state.selectedNode.notes;
    this.changeNotes(this.state.selectedNode);
    this.props.handleChange(rootCopy);
  };
  tempNotesChanged = (text) => {
    this.setState({ noteToChangeFrom: text });
  };
  addAsCopy = (copyNodeInc) => {
    // this.setState({ copyNode: { ...copyNodeInc } });
    this.setState({ copyNode: JSON.parse(JSON.stringify(copyNodeInc)) });
  };
  pasteNode = (nodeTo) => {
    // let rootCopy = { ...this.props.tree };
    let rootCopy = JSON.parse(JSON.stringify(this.props.tree));
    let node = this.findNode(nodeTo.number, rootCopy);
    // let copyNode = { ...this.state.copyNode };
    let copyNode = JSON.parse(JSON.stringify(this.state.copyNode));
    this.changeAllNumbers(copyNode);
    node.children.push(copyNode);
    this.props.handleChange(rootCopy);
  };

  changeAllNumbers = (node) => {
    node.number = uuidv4();
    if (node.children && node.children.length > 0) {
      for (let i = 0; node.children; i++) {
        this.changeAllNumbers(node.children[i]);
      }
    }
  };

  addChild = (nodeNumber, type) => {
    let childNode = {
      label: "",
      notes: "",
      children: [],
      number: uuidv4(),
      selected: false,
      type: type,
    };
    let rootCopy =
      typeof this.props.tree === "string" || this.props.tree instanceof String
        ? JSON.parse(this.props.tree)
        : { ...this.props.tree };
    let node = this.findNode(nodeNumber, rootCopy);
    node.children.push(childNode);

    this.props.handleChange(rootCopy);
    // this.setState({ incomplete: false });
    // if (this.props.setIncomplete) {
    //   this.props.setIncomplete(false);
    // }
    this.checkIfComplete(this.props.tree);
  };
  componentDidMount() {
    // this.findHighestNumber(this.props.tree, 0);
    this.setState({ incomplete: false });
    if (this.props.setIncomplete) {
      this.props.setIncomplete(false);
    }
    this.checkIfComplete(this.props.tree);
  }
  // findHighestNumber = (node, number) => {
  //   if (node.number > number) {
  //     number = node.number;
  //   }
  //   if (node.children && node.children.length > 0) {
  //     node.children.map((child) => this.findHighestNumber(child, number));
  //   } else {
  //     if (number > this.state.number) {
  //       this.setState({ number: number + 1 });
  //     }
  //   }
  // };
  checkIfComplete = (node) => {
    if (
      (!node.children || node.children.length === 0) &&
      node.type !== "decision"
    ) {
      this.setState({ incomplete: true });
      if (this.props.setIncomplete) {
        this.props.setIncomplete(true);
      }
    } else if (node.children && node.children.length > 0) {
      node.children.map((child) => this.checkIfComplete(child));
    }
  };
  findNode = (number, node) => {
    if (node.number === number) {
      return node;
    } else {
      for (let i = 0; i < node.children.length; i++) {
        let foundNode = this.findNode(number, node.children[i]);
        if (foundNode) {
          return foundNode;
        }
      }
    }
  };
  changeNotes = (node) => {
    this.setState({ editNotes: !this.state.editNotes, selectedNode: node });
  };
  selectNode = (node) => {
    let rootCopy = { ...this.props.tree };
    node = this.findNode(node.number, rootCopy);
    node.selected = true;
    this.setState({ selectedNode: node }); //had tree update
  };
  deleteNode = (parentNumber, nodeNumber) => {
    let rootCopy = { ...this.props.tree };
    let parentNode = this.findNode(parentNumber, rootCopy);
    for (let i = 0; i < parentNode.children.length; i++) {
      if (parentNode.children[i].number === nodeNumber) {
        parentNode.children.splice(i, 1);
      }
    }
    this.props.handleChange(rootCopy);
    this.setState({ incomplete: false });
    if (this.props.setIncomplete) {
      this.props.setIncomplete(false);
    }
    this.checkIfComplete(this.props.tree);
  };
  state = {
    selected: 0,
    selectedNode: {},
    title: "",
    editNotes: false,
    noteToChangeFrom: "",
    copyNode: null,
    attachmentIds:[],
  };
}
// export default DragDropContext(HTML5Backend)(DecisionTree);
export default DecisionTree;
